import { render } from "./Skills.vue?vue&type=template&id=4c4ffe23&scoped=true"
import script from "./Skills.vue?vue&type=script&lang=ts"
export * from "./Skills.vue?vue&type=script&lang=ts"

import "./Skills.vue?vue&type=style&index=0&id=4c4ffe23&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c4ffe23"

export default script